import React from "react"
export default function SG() {
  return (
    <>
      <svg
        width="32"
        height="24"
        viewBox="0 0 32 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5553_9741)">
          <rect width="32" height="24" rx="2" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask0_5553_9741"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="32"
            height="24"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 0V24H32V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_5553_9741)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 0V12H32V0H0Z"
              fill="#E31D1C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.86901 10.5891C8.86901 10.5891 6.04332 9.45258 6.04332 6.3735C6.04332 3.29443 8.86901 2.19465 8.86901 2.19465C7.49567 1.84698 3.85156 2.15794 3.85156 6.3735C3.85156 10.5891 7.44061 11.3841 8.86901 10.5891ZM9.59298 10.0801L10.4036 9.59075L11.2321 10.0801L11.0293 9.12516L11.7028 8.37182H10.7903L10.4036 7.48012L10.0169 8.37182L9.10283 8.41046L9.77788 9.12516L9.59298 10.0801ZM13.3499 9.5361L12.5393 10.0255L12.7242 9.07051L12.0491 8.35582L12.9632 8.31717L13.3499 7.42547L13.7366 8.31717H14.6491L13.9756 9.07051L14.1784 10.0255L13.3499 9.5361ZM11.2878 5.76936L12.0984 5.27999L12.9269 5.76936L12.7241 4.8144L13.3976 4.06106H12.4851L12.0984 3.16936L11.7117 4.06106L10.7976 4.09971L11.4727 4.8144L11.2878 5.76936ZM9.37039 7.22215L8.55977 7.71152L8.74467 6.75656L8.06962 6.04187L8.98367 6.00322L9.37039 5.11153L9.75711 6.00322H10.6696L9.99612 6.75656L10.1989 7.71152L9.37039 7.22215ZM13.9182 7.66767L14.7288 7.1783L15.5573 7.66767L15.3545 6.71271L16.028 5.95937H15.1155L14.7288 5.06767L14.3421 5.95937L13.428 5.99801L14.1031 6.71271L13.9182 7.66767Z"
              fill="#F1F9FF"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_5553_9741">
            <rect width="32" height="24" rx="2" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}
